import { GetStaticProps } from 'next'
import Layout from "../../../components/layout";
import React from "react";
import Link from "../../../components/Link";
import CustomerCommon from "../../../components/v2/customer/common-section";
import CallToActionSmall from "../../../components/v2/call-to-action-sm";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../../next-i18next.config";
import "../../../styles/scss/customer.module.scss";

export default function CaseStudyMindOrigin() {
    const { t } = useTranslation('common');
    const pageData = t('customers.pages.mindorigin', { returnObjects: true, defaultValue: {} }) as any;
    
    const relatedPost = Array.isArray(pageData?.relatedPosts) ? pageData.relatedPosts : [];
    const stats = Array.isArray(pageData?.stats) ? pageData.stats : [];
    const heroData = pageData?.hero || {};
    const contentData = pageData?.content || {};
    const sidebarData = pageData?.sidebar || {};

    return (
        <>
            <Layout isHomePage={false} pageTitle={String(pageData?.pageTitle ?? '')}
                    ogImage={String(pageData?.ogImage ?? '')}
                    uri={String(pageData?.uri ?? '')}
                    metaTitle={String(pageData?.metaTitle ?? '')}
                    metaDesc={String(pageData?.metaDesc ?? '')}
                    metaRobotsNoindex={String(pageData?.metaRobotsNoindex ?? 'index')}
                    metaRobotsNofollow={String(pageData?.metaRobotsNofollow ?? 'follow')}>

                <div className={"customer-inner hotplate"}>
                    <div className={"hero-section"}>
                        <div className={"container"}>
                            <div className={"d-flex"}>
                                <div className={"left-block"}>
                                    <div className={"back-btn"}><Link href={"/customers/"}>{String(heroData?.backButton ?? '')}</Link>
                                    </div>
                                    <h1>
                                        {Array.isArray(heroData?.titleParts) ? heroData.titleParts.map((part: any, idx: number) => 
                                            part.isGradient ? (
                                                <span key={idx} className={"text-gradient"}>{String(part.text ?? '')}</span>
                                            ) : (
                                                <React.Fragment key={idx}>{String(part.text ?? '')}</React.Fragment>
                                            )
                                        ) : ''}
                                    </h1>
                                </div>
                                <div className={"right-block"}>
                                    <img src={String(heroData?.image ?? '')} alt={String(heroData?.imageAlt ?? '')}
                                         width={100} height={100}/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <CustomerCommon data={stats}/>

                    <div className={"innter-content"}>
                        <div className={"container"}>
                            <div className={"d-flex"}>
                                <div className={"left-block"}>
                                    <p>{String(contentData?.intro ?? '')}</p>
                                    <div className={"customer-result"}>
                                        <h4>{String(contentData?.results?.title ?? '')}</h4>
                                        <ul>
                                            {Array.isArray(contentData?.results?.items) ? contentData.results.items.map((item: string, idx: number) => (
                                                <li key={idx}>{String(item)}</li>
                                            )) : null}
                                        </ul>
                                    </div>

                                    {Array.isArray(contentData?.contentItems) ? contentData.contentItems.map((item: any, idx: number) => {
                                        if (item.type === 'paragraph') {
                                            const text = String(item.text ?? '');
                                            // Handle Link tags in the text
                                            const processedText = text
                                                .replace(/<Link href="([^"]+)"[^>]*>([^<]+)<\/Link>/g, '<a href="$1" target="_blank">$2</a>');
                                            return <p key={`content-${idx}`} dangerouslySetInnerHTML={{ __html: processedText }} />;
                                        } else if (item.type === 'heading') {
                                            const HeadingTag = item.level === 2 ? 'h2' : item.level === 4 ? 'h4' : 'h2';
                                            return <HeadingTag key={`content-${idx}`}>{String(item.text ?? '')}</HeadingTag>;
                                        } else if (item.type === 'quote') {
                                            return (
                                                <div key={`content-${idx}`} className={"customer-quote"}>
                                                    <p>{String(item.text ?? '')}</p>
                                                    <div className={"author"}>{String(item.author ?? '')}</div>
                                                </div>
                                            );
                                        } else if (item.type === 'list') {
                                            return (
                                                <ul key={`content-${idx}`}>
                                                    {Array.isArray(item.items) ? item.items.map((listItem: any, listIdx: number) => {
                                                        const listItemText = String(listItem.text ?? '');
                                                        return <li key={`list-item-${listIdx}`} dangerouslySetInnerHTML={{ __html: listItemText }} />;
                                                    }) : null}
                                                </ul>
                                            );
                                        }
                                        return null;
                                    }) : null}

                                </div>
                                <div className={"right-block"}>
                                    <div className={"about"}>
                                        <h2>{String(sidebarData?.aboutTitle ?? '')}</h2>
                                        <p>{String(sidebarData?.description ?? '')}</p>
                                        <Link href={String(sidebarData?.cta?.primary?.link ?? '')} className={"ahref-btn primary"} target={"_blank"}>{String(sidebarData?.cta?.primary?.text ?? '')}</Link>
                                        <Link href={String(sidebarData?.cta?.secondary?.link ?? '')} className={"ahref-btn secondary"} target={"_blank"}>{String(sidebarData?.cta?.secondary?.text ?? '')}</Link>
                                        <table>
                                            <tbody>
                                            <tr>
                                                <td>Products:</td>
                                                <td>{String(sidebarData?.table?.products ?? '').split('\n').map((line: string, idx: number) => <React.Fragment key={idx}>{line}<br/></React.Fragment>)}</td>
                                            </tr>
                                            <tr>
                                                <td>Use Cases:</td>
                                                <td>{String(sidebarData?.table?.useCases ?? '').split('\n').map((line: string, idx: number) => <React.Fragment key={idx}>{line}<br/></React.Fragment>)}</td>
                                            </tr>
                                            <tr>
                                                <td>Industries:</td>
                                                <td>{String(sidebarData?.table?.industries ?? '')}</td>
                                            </tr>
                                            <tr>
                                                <td>Location:</td>
                                                <td>{String(sidebarData?.table?.location ?? '')}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={"more-story customer-inner-page"}>
                        <div className={"container"}>
                            <h2>{String(pageData?.moreCaseStudiesTitle ?? '')}</h2>

                            <div className={"d-flex"}>
                                {
                                    relatedPost.map((customer: any, index: number) => {
                                        return <div className={`customers ${String(customer.className ?? '')}`} key={index}>
                                            <div className={`logo `}><img src={String(customer.image ?? '')} alt={String(customer.title ?? '')}/>
                                            </div>
                                            <h3>{String(customer.title ?? '')}</h3>
                                            <Link href={String(customer.link ?? '')} className={"read-more"}>Read More</Link>
                                        </div>
                                    })
                                }
                            </div>

                        </div>
                    </div>
                    <CallToActionSmall/>
                </div>

            </Layout>
        </>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
    const translations = await serverSideTranslations(
        ctx?.locale ?? "en",
        ["common", "header", "footer"],
        nextI18NextConfig,
    );
    return {
        props: {
            ...translations,
            pageData: "",
            pageTitle: "How Middleware Helped MindOrigin Cut Observability Costs by 75%",
            description: "Learn how Middleware helped MindOrigin streamline its infrastructure management, unify log data, improve MTTR, and reduce observability costs.",
            ogImage: "/images/case-study/mindorigin-og.png",
            uri: "/customers/mindorigin/",
            metaTitle: "How Middleware Helped MindOrigin Cut Observability Costs by 75%",
            metaDesc: "Learn how Middleware helped MindOrigin streamline its infrastructure management, unify log data, improve MTTR, and reduce observability costs.",
            metaRobotsNoindex: "",
            metaRobotsNofollow: "",
        },
    }
}
